import React from 'react'
import { useParams, Outlet } from 'react-router-dom'
import ClinicThemeShell from './ClinicThemeShell'

const ClinicLayout = () => {
  const { clinicId } = useParams()

  return (
    <ClinicThemeShell clinicId={clinicId}>
      {({ clinicContent, clinicName }) => (
        <Outlet context={{ clinicContent, clinicName }} />
      )}
    </ClinicThemeShell>
  )
}

export default ClinicLayout
